const controlItem = {
  state: () => ({
    /** 管制項目之Tab名稱如新增、編輯 */
    tabShow: '',

    /** 選取的管制項目代碼 */
    levelSettingItem: '',

    /** 管制項目之複製對話框是否顯示 */
    copyDialogVisible: false,

    /** 選取的管制項目資訊 */
    selectedDataItem: null,

    /** 按下檢視查看的管制項目Tab資料 */
    selectedOneControlTab: {},

    /** 資料匯入選取的項目 */
    dataImportControlItem: null,

    /** 樣本管理正在使用的Tab名稱 */
    sampleManagementActiveTabName: '',

    /** 變更履歷正在使用的Tab名稱 */
    historyActiveTabName: '',

    /** 合圖查詢產生Tabs的資料列表 */
    chartTabList: [],

    /** 不啟用進階搜尋按鈕 */
    btnAdvanceSearchDisabled: false,

    /** 進階搜尋對話框是否開啟 */
    advanceSearchDialogVisible: false,

    /** 目前製程能力分析的Tab索引位置 */
    processAnalysisActiveTab: 0,

    /** 計數型、計量型Checkbox資料列表 */
    chartIDList: [],

    /** 選取計數型、計量型的資料類型 */
    selectChartDataType: '0',

    /** 管制項目資訊檢視選取的Tab名稱 */
    controlItemSelectedTabName: '',

    /** 隱藏點處理資料列表 */
    hiddenPointDataTable: [],

    /** 編輯點處理資料列表 */
    modifyPointDataTable: [],

    /** 管制線變更履歷資料列表 */
    controlLineChangeLogDataList: [],

    /** 管制圖規則履歷資料列表 */
    controlChartRuleLogDataList: [],

    /** Pareto需要的Graph資料 */
    paretoGraph: [],

    /** Pareto需要的histogram資料 */
    paretoHistogram: [],

    /** 管制項目資訊項目列表 */
    controlIdList: [],

    /** 管制項目設定新增編輯對話框是否顯示 */
    createEditDialogVisible: false,

    /** 選取的圖表列表 */
    chartIdList: [],
  }),

  mutations: {
    /** 管制項目之Tab名稱如新增、編輯 設值 */
    setTabShow(state, value) {
      state.tabShow = value;
    },

    /** 選取的管制項目代碼 */
    setLevelSettingItem(state, value) {
      state.levelSettingItem = value;
    },

    /** 管制項目之複製對話框是否顯示 設值 */
    setCopyDialogVisible(state, value) {
      state.copyDialogVisible = value;
    },

    /** 選取的管制項目資訊 設值 */
    setSelectedDataItem(state, value) {
      state.selectedDataItem = value;
    },

    /** 按下檢視查看的管制項目Tab資料 設值 */
    setSelectedOneControlTab(state, value) {
      state.selectedOneControlTab = value;
    },

    /** 資料匯入選取的項目 設值 */
    setDataImportControlItem(state, value) {
      state.dataImportControlItem = value;
    },

    /** 樣本管理正在使用的Tab名稱 設值 */
    setSampleManagementActiveTabName(state, value) {
      state.sampleManagementActiveTabName = value;
    },

    /** 變更履歷正在使用的Tab名稱 設值 */
    setHistoryActiveTabName(state, value) {
      state.historyActiveTabName = value;
    },

    /** 合圖查詢產生Tabs的資料列表 設值 */
    setChartTabList(state, value) {
      state.chartTabList = value;
    },

    /** 不啟用進階搜尋按鈕 設值 */
    setBtnAdvanceSearchDisabled(state, value) {
      state.btnAdvanceSearchDisabled = value;
    },

    /** 進階搜尋對話框是否開啟 設值 */
    setAdvanceSearchDialogVisible(state, value) {
      state.advanceSearchDialogVisible = value;
    },

    /** 目前製程能力分析的Tab索引位置 設值 */
    setProcessAnalysisActiveTab(state, value) {
      state.processAnalysisActiveTab = value;
    },

    /** 計數型、計量型Checkbox資料列表設值 */
    setChartIDList(state, value) {
      state.chartIDList = value;
    },

    /** 選取計數型、計量型的資料類型 設值 */
    setSelectChartDataType(state, value) {
      state.selectChartDataType = value;
    },

    /** 管制項目資訊檢視選取的Tab名稱 設值 */
    setControlItemSelectedTabName(state, value) {
      state.controlItemSelectedTabName = value;
    },

    /** 隱藏點處理資料列表 設值 */
    setHiddenPointDataTable(state, value) {
      state.hiddenPointDataTable = value;
    },

    /** 編輯點處理資料列表 設值 */
    setModifyPointDataTable(state, value) {
      state.modifyPointDataTable = value;
    },

    /** 管制線變更履歷資料列表 設值 */
    setControlLineChangeLogDataList(state, value) {
      state.controlLineChangeLogDataList = value;
    },

    /** 管制圖規則履歷資料列表 設值 */
    setControlChartRuleLogDataList(state, value) {
      state.controlChartRuleLogDataList = value;
    },

    /** Pareto需要的Graph資料 */
    setParetoGraph(state, value) {
      state.paretoGraph = value;
    },

    /** Pareto需要的histogram資料 */
    setParetoHistogram(state, value) {
      state.paretoHistogram = value;
    },

    /** 管制項目資訊項目列表 設值 */
    setControlIdList(state, value) {
      state.controlIdList = value;
    },

    /** 管制項目設定新增編輯對話框是否顯示 設值 */
    setCreateEditDialogVisible(state, value) {
      state.createEditDialogVisible = value;
    },

    /** 選取的圖表列表 設值 */
    setChartIdList(state, value) {
      state.chartIdList = value;
    },
  },
};

export default controlItem;
